// Service worker deshabilitado para evitar cache agresiva en producción.
// Este archivo asegura que no se registren service workers residuales.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      registrations.forEach((registration) => {
        registration.unregister();
      });
    })
    .catch((error) => {
      console.error('Error al limpiar service workers:', error);
    });
}

